import { Injectable } from "@angular/core";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";

class Config {
  self: any;
  listName: string;
  url: string;
  callback?: any;
  skip?: number;
  limit?: number;
}

@Injectable()
export class ListService {
  config: Config;

  public isLoading = false;

  public fromRoot = true;
  public scrollDistance = 1;
  public scrollThrottle = 60;
  public scrollDisabled = true;
  // fix(shell): retargeted from `.mat-drawer-content` (Material's
  // mat-sidenav-container auto-generated wrapper — stale since C3-2's
  // vng-sidenav swap, since vng-sidenav never rendered that class either)
  // to `.app-content`, the new shell's stable scrollable main-content class
  // (admin-layout.component.html / admin-layout.component.scss). This is
  // what ngx-infiniteScroll's [infiniteScrollContainer] binding
  // (shortcuts.component.html / templates.component.html) actually scrolls.
  public scrollContainer = ".app-content";

  constructor(private dataService: DataService) {}

  init(config: Config, data: any[]) {
    this.config = config;
    this.config.skip = this.config.skip || 0;
    this.config.limit = this.config.limit || 10;
    this.config.self[this.config.listName] = [];
    this.appendResult(data);
  }

  appendResult(list: any[], retainLimit?: boolean) {
    if (Array.isArray(list)) {
      const existing = this.config.self[this.config.listName] || [];
      const existingIds = new Set(existing.map((x: any) => x?.id));
      const incoming = retainLimit ? list : list.filter((x: any) => !existingIds.has(x?.id));

      this.config.self[this.config.listName] = retainLimit ? list : existing.concat(incoming);

      // Advance pagination by what the backend returned (not by what we kept),
      // so skip stays aligned with the server's page window.
      this.config.skip += list.length;
      this.scrollDisabled = list.length < this.config.limit;

      if (typeof this.config.callback === "function") {
        this.config.callback();
      }
    } else {
      this.scrollDisabled = true;
    }
  }

  getList(retainLimit?: boolean) {
    if (this.isLoading) return;
    let limit = this.config.limit;
    if (retainLimit) {
      this.config.skip = 0;
      const len = this.config.self[this.config.listName].length;
      limit = len < this.config.limit ? this.config.limit : len;
    }

    this.isLoading = true;
    this.dataService
      .get({
        url: this.config.url + "skip=" + this.config.skip + "&limit=" + limit,
        isLoader: false,
      })
      .subscribe(
        (response: any) => {
          this.isLoading = false;
          if (response && response.result) {
            this.appendResult(response.result, retainLimit);
          }
        },
        () => {
          this.isLoading = false;
        }
      );
  }
}
